<!--新增预订单-->
<template>
  <div class='cateringCreate-page'>
    <topNav :title="$t('cateringCreate_title')"
            :selfMethod='1'
            @leftClick='goBack'></topNav>

    <div class="form">
      <div class='basic-user-info'>
        <div class="info">
          <label>{{$t('cateringCreate_workstation')}} <i class="must">*</i></label>
          <div class="parent">
            <gpicker ref="pccode"
                     @change="changePccode"></gpicker>
          </div>
        </div>

        <div class="info">
          <label>{{$t('cateringCreate_peopleNumber')}} <i class="must">*</i></label>
          <input class="inp"
                 type="number"
                 :placeholder="$t('cateringCreate_peopleNumber_placeholder') "
                 v-model='formDetail.gsts'>
        </div>

        <div class="info">
          <label>{{$t('cateringCreate_bookDate')}} <i class="must">*</i></label>
          <div class="parent"
               style='height: 32px;'>
            <datepicker v-model="formDetail.resDate"
                        @input="dpselect"
                        ref='caterDatepicker'
                        class="picker picker-range"
                        :min="start"
                        :max="end"
                        :hideClear='true'
                        :range="false"></datepicker>
          </div>
        </div>
        <div class="info">
          <label>{{$t('cateringCreate_bookTime')}} <i class="must">*</i></label>
          <div class="parent"
               @click="openPicker"
               style='height: 32px;'>
            <input type="text"
                   :placeholder="$t('cateringCreate_bookTime_placeholder')"
                   v-model='formDetail.arrtime'
                   style='color: #000;height: auto;outline: none;'
                   class="eventTimeInput"
                   readonly>
          </div>
        </div>
        <mt-datetime-picker ref="pickerEventTime"
                            :cancelText="$t('cancel')"
                            :confirmText="$t('determine')"
                            v-model="formDetail.arrtime"
                            type='time'
                            @confirm="pickTime"></mt-datetime-picker>

        <div class="info">
          <label>{{$t('cateringCreate_linkman')}} <i class="must">*</i></label>
          <input class="inp"
                 type="text"
                 :placeholder="$t('cateringCreate_linkman_placeholder') "
                 maxlength="11"
                 v-model='formDetail.emp'>
        </div>

        <div class="info">
          <label>{{$t('cateringCreate_phone')}} <i class="must">*</i></label>
          <input class="inp"
                 type="number"
                 :placeholder="$t('cateringCreate_phone_placeholder') "
                 maxlength="11"
                 v-model='formDetail.phone'>
        </div>

        <div class="info">
          <label>{{$t('cateringCreate_tableType')}}</label>
          <div class="parent">
            <gpicker ref="tableType"
                     @change="changeTableType"></gpicker>
          </div>
        </div>
        <div class="info">
          <label>{{$t('cateringCreate_tableNo')}}</label>
          <div class="parent">
            <gpicker ref="tableNo"
                     @change="changeTableNo"></gpicker>
          </div>
        </div>

<!--        销售-->
        <div class="info">
          <label>{{$t('book_salesman')}}</label>
          <div class="parent" @click="openSaleSelect">
            <div>
                  <span v-if="choosedSaleManCode">
                    {{choosedSaleMan.code}} -- {{choosedSaleMan.name}}
                  </span>
              <span style="color: #ccc" v-else>选择销售员</span>
            </div>
            <span class="iconfont icon-xia"></span>
          </div>
        </div>
<!--        用餐标准-->
        <div class="info">
          <label>{{$t('cateringDetail_amount')}}</label>
          <input class="inp"
                 type="number"
                 :placeholder="$t('cateringDetail_amount')"
                 maxlength="11"
                 v-model='formDetail.standardAmount'>
        </div>
<!--        标准类型-->
        <div class="info">
          <label>{{$t('cateringDetail_standardType')}}</label>
          <div class="parent">
            <gpicker ref="standardType"
                     @change="changeStandardType"
                     :placeholder="$t('cateringDetail_standardType')"></gpicker>
          </div>
        </div>

        <div class="info">
          <!-- 备注-->
          <label>{{$t('remark')}}</label>
          <textarea class="remark"
                    v-model="formDetail.info"
                    cols='5'
                    :placeholder="$t('placeHolder_Empty')"></textarea>
        </div>

        <div class='btn-fixed-bottom'
             @click='doAddOrder'>{{$t('reservation')}}
        </div>
      </div>
    </div>

    <div class='edit-ratecode-modal'
         v-if='showSaleSelect'>
      <div class='edit-ratecode-modal-container'>
        <div class='edit-ratecode-title'>
          {{ $t('book_salesman') }}
          <i class='iconfont icon-cuowu'
             @click='closeSaleSelect'></i>
        </div>

        <div class='search-rate-wrap'>
          {{ $t('search') }}：<input class="spe-search" v-model="searchSaleMan" type="text">
        </div>
        <div class="ratecode-modal-body">
          <div class="right-arr" style="width: 100%" v-if="saleManList.length">
            <div class="right-item spe"
                 v-show="!searchSaleMan || ((item.code.indexOf(searchSaleMan) > -1) || (item.name.indexOf(searchSaleMan) > -1))"
                 :class="item.code == choosedSaleManCode ? 'active' : ''"
                 v-for="(item,index) in saleManList"
                 @click="setCurrentSaleMan(item)"
                 :key="'saleMan' + index">
              {{ item.code }} -- {{ item.name }}
            </div>
          </div>
          <div class="right-arr" style="width: 100%" v-else>
            <div class="right-item spe no-data">
              {{ $t('nothing') }}
            </div>
          </div>
        </div>
        <div class='edit-ratecode-footer'>
          <div class='edit-ratecode-btn ratecode-cancel-btn'
               @click='closeSaleSelect'>{{ $t('cancel') }}
          </div>
          <div class='edit-ratecode-btn'
               @click='changeSale'>{{ $t('determine') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment";
  import Datepicker from "../../common/Datepicker";
  import gpicker from "../../common/gpicker";

  export default {
    data() {
      return {
        formDetail: {
          pccode: '', // 营业点
          gsts: '', // 就餐人数
          resDate: '', // 日期
          arrtime: '18:00', // 时间
          emp: '', // 联系人
          phone: '', // 联系电话
          tableType: '',
          tableno: '',
          info: '',
          channel: 'mihotel', // 渠道，写死 mihotel
          salesCode: '',
          salesName: '',
          standardAmount: null,
          standardType: '',
        },
        isReserve: true, //是否步入预订
        more: false,
        start: moment().format("YYYY-MM-DD"),
        end: moment().add(24, "M").format("YYYY-MM-DD"),

        showSaleSelect: false,
        selectedSale: '',
        saleManList: [],
        searchSaleMan: '',
        choosedSaleMan: {},
        choosedSaleManCode: '',
      };
    },
    mounted() {
      var query = this.$route.query || {}
      if(query.from == 'gant'){
        this.formDetail.pccode = query.pccode
        this.dpselect(query.date)
      }
      this.getHotelPccodes()
      this.getSalesman();
      this.getStandardType();
    },
    methods: {
      async getSalesman() {
        await this.$http
          .get("/mobilepmsapi/sys/pmsPrarms?type=SALES_MAN")
          .then(res => {
            if (res.data.result == 0) {
              this.saleManList = res.data.retVal || []
            }
          });
      },
      openSaleSelect(){
        this.showSaleSelect = true
      },
      closeSaleSelect(){
        this.showSaleSelect = false
        this.formDetail.salesCode = this.choosedSaleManCode
        this.formDetail.salesName = this.choosedSaleMan.name
      },
      setCurrentSaleMan(item) {
        this.choosedSaleMan = item || {}
        this.choosedSaleManCode = item.code || ''
      },
      changeSale(){
        this.showSaleSelect = false
        this.formDetail.salesCode = this.choosedSaleManCode
        this.formDetail.salesName = this.choosedSaleMan.name
      },

      getStandardType(){
        let arr = [{
          code: 'A',
          name: '/桌',
        },{
          code: 'B',
          name: '/人',
        },{
          code: 'C',
          name: '/场',
        },{
          code: 'D',
          name: '/天',
        },]
        this.$refs.standardType.setData(
          arr,
          null,
          this.disCodeName2
        );
      },
      changeStandardType(val){
        this.formDetail.standardType = val
      },
      disCodeName(v) {
        return v.code + " -- " + v.name;
      },
      disCodeName2(v) {
        return  v.name;
      },
      goBack() {
        this.$router.back()
      },
      dpselect(v) {
        this.formDetail.resDate = v;
        this.$refs.caterDatepicker.setValue(v);
        this.getTableNo()
      },

      //弹框
      openPicker() {
        this.$refs.pickerEventTime.open();
      },
      //分割时间
      pickTime(value) {
        this.formDetail.arrtime = value
        this.getTableNo()
      },
      changePccode() {
        this.formDetail.pccode = this.$refs.pccode.getValue();
        this.getTableTypes();
        this.getTableNo()
      },
      changeTableType() {
        this.formDetail.tableType = this.$refs.tableType.getValue();
        this.getTableNo()
      },
      changeTableNo() {
        this.formDetail.tableno = this.$refs.tableNo.getValue();
      },
      getHotelPccodes() {
        /*获取餐厅列表*/
        this.$http.get("/mobilepmsapi/reception/getPosPcCode").then(res => {
          if (res.data.result == 0) {
            let retVal = res.data.retVal || {}
            let defaultValue = null
            if (retVal.length > 0) {
              if(this.formDetail.pccode){
                defaultValue = this.formDetail.pccode
              } else {
                defaultValue = retVal[0].code
                this.formDetail.pccode = retVal[0].code
              }
              this.getTableTypes()
              this.getTableNo()
            }
            this.$refs.pccode.setData(retVal, defaultValue, this.disPccodeName);
          } else {
            this.msg2(res.data.msg)
          }
        });
      },

      disPccodeName(v) {
        return v.code + " -- " + v.name;
      },
      disTableNoName(v) {
        return v.code + " -- " + v.descript;
      },
      getTableTypes() {
        this.formDetail.tableType = '';
        this.$http.post("/mobilepmsapi/pos/getTableTypes", {
          pccode: this.formDetail.pccode
        }).then(res => {
          if (res.data.result == 0) {
            let retVal = res.data.retVal || {}
            this.$refs.tableType.setData(retVal, null, this.disPccodeName);
            this.$refs.tableType.setDefault(null);
          } else {
            this.msg2(res.data.msg)
          }
        });
      },
      getTableNo() {
        this.formDetail.tableno = '';
        let pccode = this.formDetail.pccode
        let resDate = this.formDetail.resDate
        let arrtime = this.formDetail.arrtime
        let tableType = this.formDetail.tableType || ''
        if(pccode && resDate && arrtime){
          let param = {
            pccode: pccode,
            resDate: resDate, // 日期
            resTime: arrtime, // 时间
            tableType: tableType
          }
          this.$http.post("/mobilepmsapi/pos/getTables", param).then(res => {
            if (res.data.result == 0) {
              let retVal = res.data.retVal || {}
              this.$refs.tableNo.setData(retVal, null, this.disTableNoName);
              this.$refs.tableNo.setDefault(null);
            } else {
              this.msg2(res.data.msg)
            }
          });
        }
      },
      validForm() {
        let formDetail = this.formDetail || {}
        if (_.isEmpty(formDetail.pccode)) {
          this.msg2(this.$t('cateringCreate_notice_workstation'));
          return false
        }
        if (_.isEmpty(formDetail.gsts)) {
          this.msg2(this.$t('cateringCreate_peopleNumber_placeholder'));
          return false
        }
        if (_.isEmpty(formDetail.resDate)) {
          this.msg2(this.$t('cateringCreate_notice_bookDate'));
          return false
        }
        if (_.isEmpty(formDetail.arrtime)) {
          this.msg2(this.$t('cateringCreate_bookTime_placeholder'));
          return false
        }
        if (_.isEmpty(formDetail.emp)) {
          this.msg2(this.$t('cateringCreate_linkman_placeholder'));
          return false
        }
        if (_.isEmpty(formDetail.phone)) {
          this.msg2(this.$t('cateringCreate_phone_placeholder'));
          return false
        }
        return true
      },

      doAddOrder() {
        if (this.validForm()) {
          let formDetail = this.formDetail || {}
          this.$http.post("/mobilepmsapi/pos/addPosResMaster", formDetail)
            .then(res => {
              if (res.data.result == 0) {
                this.msg2(this.$t('cateringCreate_notice_success'))
                setTimeout(() => {
                  this.$router.back()
                }, 1000)
              } else {
                this.msg2(res.data.msg)
              }
            });
        }
      },
    },

    components: {
      Datepicker,
      gpicker,
    },
  };
</script>

<style lang="less">
  @import "cateringCreate";
</style>



// WEBPACK FOOTER //
// cateringCreate.vue?4f4aabfe